import { Flex, xcss } from '@atlaskit/primitives';

import { JfindOnboardIllustrationRefresh } from '@/templates/ondemand/signup/confirmation/confirmation-page/src/views/onboarding-wizard/wizard/variant/jfind-onboard-illustration-refresh/jfind-onboard-illustration-refresh';

import { RightHandSideProps } from '../../../common/types';
import {
	useGetSelectedCodingAgentAvatarsFromSearchParams,
	useIllustrationViewType,
} from '../../../controllers';
import { BoardColumnsSvg } from '../../assets/board-columns-svg';
import { Injections, ProjectSvg } from '../../assets/project-svg';

import { CollaborationIcons } from './collaboration-icons';
export const RightHandSidePageInvite = ({
	projectName,
	columnNames,
	isIllustrationRefresh,
}: RightHandSideProps & { columnNames: string[]; isIllustrationRefresh: boolean }) => {
	const assignedAgents = useGetSelectedCodingAgentAvatarsFromSearchParams();
	const illustrationViewType = useIllustrationViewType();
	const injections: Injections = {
		additionalObject: CollaborationIcons,
		svgBody: BoardColumnsSvg({ columnNames, assignedAgents }),
	};
	if (isIllustrationRefresh) {
		return (
			<JfindOnboardIllustrationRefresh
				viewType={illustrationViewType}
				projectName={projectName}
				isInviteStep
			/>
		);
	}
	return (
		<Flex alignItems="center" justifyContent="center" xcss={containerStyles}>
			<ProjectSvg projectName={projectName} activeView="board" injections={injections} />
		</Flex>
	);
};
const containerStyles = xcss({
	height: '100%',
	backgroundColor: 'elevation.surface',
});
